<template>
  <b-modal
    v-if="selected"
    id="cloneUniversityDirectionModal"
    size="lg"
    title="Копирование направления университета"
    @show="updateData"
    @ok="onSave"
  >
    <div>
      <strong>Направление:</strong> {{ selected.educationDirection.title }}
    </div>
    <div class="mt-2">
      <strong>Текущий тип:</strong> {{ currentType }}
    </div>
    <div class="mt-3">
      <h5>Типы для копирования</h5>
      <b-form-checkbox-group v-model="newTypes">
        <div
          class="mb-2"
          v-for="(option, index) in otherTypes"
          :key="index"
        >
          <b-form-checkbox
            :value="option.value"
          >
            {{ option.text }}
            <span
              v-if="existTypes.includes(option.value)"
              title="Направление с данным типом будет перезаписано"
            >
              <em>(Замена)</em>
            </span>
          </b-form-checkbox>
        </div>
      </b-form-checkbox-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button @click="ok" variant="primary">
        Копировать
      </b-button>
      <b-button @click="cancel" variant="outline-primary">
        Отмена
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { studyingForms } from '@/config/studying-forms'

export default {
  name: 'CopyUniversityDirectionModal',
  props: {
    selected: {
      type: Object,
      default() {
        return null
      }
    },
    existTypes: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      newTypes: []
    }
  },
  computed: {
    currentType() {
      if (!this.selected) {
        return '?'
      }
      const form = studyingForms.find((sf) => sf.value === this.selected.studyingForm)
      return form ? form.text : '?'
    },
    otherTypes() {
      if (!this.selected) {
        return []
      }
      return studyingForms.filter((sf) => sf.value !== this.selected.studyingForm)
    }
  },
  methods: {
    updateData() {
      this.newTypes = []
    },
    onSave() {
      this.$emit('save', this.newTypes)
    }
  }
}
</script>

<style scoped>

</style>
